export {
  default as creditCard,
  ReactComponent as CreditCard,
} from '@assets/icons/creditCard.svg'    
